import client from "../client/client";

class ProfilePictureService {
	getByCompany({ companyId, userId }, cancelToken) {
		return client.get(`/profile-picture/companies/${companyId}/users/${userId}`, {
			config: {
				cancelToken,
				responseType: "blob",
			},
		});
	}

	getByProject({ projectId, userId }, cancelToken) {
		return client.get(`/profile-picture/projects/${projectId}/users/${userId}`, {
			config: {
				cancelToken,
				responseType: "blob",
			},
		});
	}
}

export default new ProfilePictureService();
